var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPic2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 52,
    viewBox: "0 0 101 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_740_1025)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.03662 34.9412C7.36166 35.0979 7.97826 35.3673 11.7448 31.9582C16.453 27.6967 20.7332 24.7137 25.4414 28.549C30.1497 32.3843 33.1458 41.7595 39.1381 39.2027C45.1303 36.6458 47.2704 17.4692 54.5467 14.9123C61.8231 12.3555 66.5313 27.2706 71.6675 19.1738C76.8037 11.077 82.368 0.849604 86.2202 2.12804C89.3019 3.15079 92.3551 7.38386 93.4965 9.37256",
    stroke: "#3594FF",
    strokeWidth: 1.51049
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_740_1025",
    x: 0.666782,
    y: 0.507451,
    width: 99.5268,
    height: 51.2145,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.28671
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.02098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.654902 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_740_1025"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_740_1025",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPic2);
export default __webpack_public_path__ + "static/media/pic2.c76ad8b0abe4b3a7631863d76ad4b163.svg";
export { ForwardRef as ReactComponent };